import React, { useEffect, useState } from 'react';
import Container from '@/components/container';
import { Form, Input, Button, Select, Table, Row, Col, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { CHECK_STATUS, SYNC_STATUS, SYNC_STATUS_MAP } from './data';
import ComponentLog from '@/components/component-log';
import BlockWrapper from '@/components/edit-activity-plan/block-wrapper';
import apis from '../apis';
import './index.less';
// import { enhancedFormateTimeStamp } from '@/common/utils/format-time'
import CheckStatus from './components/check-status';
import CheckDetail from './components/check-detail';
import ChangeHover from './components/change-hover';
const { Option } = Select;

const ResourceManage = () => {
  const initParam = {
    outActivityId: undefined,
    applyId: undefined,
    checkStatus: undefined,
    syncStatus: undefined,
    pageSize: 10,
    page: 1,
  };
  const [conditions, setConditions] = useState(initParam);
  const [data, setData] = useState({
    items: [],
    loading: false,
    totalCount: 0,
  });
  // 查看资源位详情、审核
  const [isDrawerShow, setIsDrawerShow] = useState(false);
  const [checkInfo, setCheckInfo] = useState('');

  const columns = [
    {
      align: 'center',
      title: '资源申请编号',
      width: 100,
      render: (data) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {/* {
              data.originalApplyId ? (
                <div className='resource-manage-change'>改</div>
              ) : null
            } */}
            <ChangeHover originalApplyId={data.originalApplyId} />
            <div>{data.id}</div>
          </div>
        );
      },
    },
    {
      align: 'center',
      title: '资源位名称',
      render: (data) => {
        return (
          <div>{data.homeFloorInfo && data.homeFloorInfo.resourceName ? data.homeFloorInfo.resourceName : '-'}</div>
        );
      },
      width: 120,
    },
    {
      align: 'center',
      title: '频道名称',
      width: 100,
      render: (data) => {
        return <div>{data.homeFloorInfo && data.homeFloorInfo.channelName ? data.homeFloorInfo.channelName : '-'}</div>;
      },
    },
    {
      align: 'center',
      title: '频道ID',
      width: 100,
      render: (data) => {
        return <div>{data.homeFloorInfo && data.homeFloorInfo.channelId ? data.homeFloorInfo.channelId : '-'}</div>;
      },
    },
    {
      align: 'center',
      title: '申请人',
      width: 150,
      dataIndex: 'applyPin',
    },
    {
      align: 'center',
      title: '申请时间',
      width: 150,
      dataIndex: 'created',
      // render: (data) => {
      //   return (
      //     <div>
      //       {enhancedFormateTimeStamp(data.created, 'YY-MM-DD hh:mm')}
      //     </div>
      //   )
      // }
    },
    {
      align: 'center',
      title: '资源申请状态',
      width: 150,
      render: (data) => {
        return (
          <div className="resource-status-tool">
            {data.checkStatus === 3 ? (
              <div>
                <CheckStatus checkStatus={data.checkStatus} />
                <Tooltip placement="top" title={'失败原因：' + data.remark}>
                  <InfoCircleOutlined />
                </Tooltip>
              </div>
            ) : (
              <CheckStatus checkStatus={data.checkStatus} />
            )}
          </div>
        );
      },
    },
    {
      align: 'center',
      title: '同步状态',
      width: 150,
      render: (data) => {
        const remark = data.remark ? data.remark : '修改后的申请已审核通过，原申请自动失效';
        return (
          <div>
            {data.syncStatus === 3 || data.syncStatus === 4 ? (
              <div>
                {SYNC_STATUS_MAP[data.syncStatus]}
                <Tooltip placement="top" title={'失败原因：' + remark}>
                  <InfoCircleOutlined style={{ marginLeft: '5px' }} />
                </Tooltip>
              </div>
            ) : (
              SYNC_STATUS_MAP[data.syncStatus]
            )}
          </div>
        );
      },
    },
    {
      align: 'center',
      title: '操作',
      width: 80,
      render: (data) => {
        return (
          <ComponentLog>
            <a
              clstag={data.checkStatus === 0 ? 'resource_1627030927203|3' : 'resource_1627030927203|4'}
              onClick={() => {
                setIsDrawerShow(true);
                setCheckInfo(data);
              }}
            >
              {data.checkStatus === 0 ? '立即审核' : '查看'}
            </a>
          </ComponentLog>
        );
      },
    },
  ];
  const [form] = Form.useForm();
  const formRowLayout = {
    justify: 'flex-start',
    align: 'middle',
    gutter: 16,
  };
  const onFinish = (value) => {
    setConditions((conditions) => ({ ...conditions, ...value, page: 1, pageSize: 10 }));
  };
  const [resourceList, setResourceList] = useState([]);
  useEffect(() => {
    apis
      .getResourceState()
      .then((res) => {
        if (res && res.ret === '0') {
          const resourceStates = res.data.resourceStates;
          resourceStates.unshift({ resourceName: '全部', resourceStateCode: '' });
          setResourceList(resourceStates);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    setData((data) => ({ ...data, loading: true }));
    apis
      .checkReadServicequeryForHomeFloorList(conditions)
      .then((res) => {
        const {
          ret,
          data: { items, totalCount },
        } = res;
        if (ret === '0') {
          setData({
            items: items,
            loading: false,
            totalCount: totalCount,
          });
        } else {
          setData((data) =>
            Object.assign({}, data, {
              items: [],
              loading: false,
              totalCount: 0,
            })
          );
        }
      })
      .catch((ex) => {
        setData((data) =>
          Object.assign({}, data, {
            items: [],
            loading: false,
            totalCount: 0,
          })
        );
      });
  }, [conditions]);

  // 刷新列表
  const refreshList = () => {
    setConditions({ ...conditions });
  };

  return (
    <>
      <Container>
        <div style={{ paddingTop: '15px' }}>
          <Form form={form} onFinish={onFinish}>
            <Row {...formRowLayout}>
              <Col span={4}>
                <Form.Item name="outActivityId" label="资源位">
                  <Select defaultValue="" allowClear>
                    {resourceList.map((item) => (
                      <Option value={item.resourceStateCode} key={item.resourceStateCode}>
                        {item.resourceName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item
                  label="申请编号"
                  name="applyId"
                  rules={[
                    {
                      required: false,
                      pattern: new RegExp(/^[1-9]\d*$/, 'g'),
                      message: '请输入正确编号',
                    },
                  ]}
                >
                  <Input maxLength={20} placeholder="请输入申请编号" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="checkStatus" label="申请状态">
                  <Select defaultValue="" allowClear>
                    {CHECK_STATUS.map((item) => (
                      <Option value={item.val} key={item.val}>
                        {item.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="syncStatus" label="同步状态">
                  <Select defaultValue="" allowClear>
                    {SYNC_STATUS.map((item) => (
                      <Option value={item.val} key={item.val}>
                        {item.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Row align="middle" justify="end">
                  <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ marginRight: '16px' }}>
                      查询
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button onClick={() => form.resetFields()} type="submit">
                      重置
                    </Button>
                  </Form.Item>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>
      <Container>
        <BlockWrapper title="资源申请管理">
          <Table
            rowKey="materialId"
            columns={columns}
            loading={data.loading}
            dataSource={data.items}
            pagination={{
              current: conditions.page,
              total: data.totalCount,
              pageSize: conditions.pageSize,
              onChange: (toPage) => {
                setConditions({
                  ...conditions,
                  page: toPage,
                });
              },
              showSizeChanger: false,
            }}
          />
        </BlockWrapper>
      </Container>
      <CheckDetail
        refreshList={refreshList}
        data={checkInfo}
        visible={isDrawerShow}
        onClose={() => setIsDrawerShow(false)}
      />
    </>
  );
};

export default ResourceManage;
